import { tr } from 'i18n';
import { PartialMenuItemType } from 'interfaces';
import { MenuItemType } from 'interfaces/navigation.types';
import { isSameHostname, isWebFileUrl } from 'utils';
import { ROUTES } from 'constants/index';

const createMaxMenuItem = (menuItem: PartialMenuItemType): MenuItemType => {
  const { targetEntity, targetId } = menuItem;
  const target = targetEntity?.toLocaleLowerCase();

  let link = '';
  if (targetEntity === 'ChallengePhoto') {
    link = `${ROUTES.CHALLENGE}/${targetId}`;
  }
  if (targetEntity === 'Challenge') {
    link = `${ROUTES.CHALLENGE}/${targetId}`;
  }
  if (targetEntity === 'Form') {
    link = `/#/${target}/${targetId}`;
  } else {
    link = `/${target}/${targetId}`;
  }

  /*
    case targetEntity === 'Form' (Quizz)
    A link toward a fov1 page is not targetted by our fov2 router
    So we consider it as external link
  */
  return {
    id: menuItem.id.toString(),
    label: menuItem.label,
    ...(targetEntity === 'Form'
      ? { externalRoute: link }
      : { reactRoute: link }),
  };
};

export const createExternalLink = (
  menuItem: PartialMenuItemType,
): MenuItemType => {
  return {
    id: menuItem.id.toString(),
    label: menuItem.label,
    externalRoute: menuItem.link,
    shouldOpenNewTab:
      !isSameHostname(menuItem.link!) && !isWebFileUrl(menuItem.link!),
  };
};

/* 
    When a custom menu is created in the BO,
    the backend create a new menu item.
    If the menu is an external link at MAX application, there is a key named "link":
    {
      "@context": "/v2/contexts/Menu",
      "@id": "/v2/menus/7",
      "@type": "Menu",
      "id": 7,
      "label": "TEST EXTERNAL LINK",
      "targetEntity": null,
      "targetId": 0,
      "link": "https://google.com",
      "position": 6
    }

    If the menu is a link toward a page of MAX application (fov1/fov2), there are
    a key named "targetEntity" and "targetId":
    {
      "@context": "/v2/contexts/Menu",
      "@id": "/v2/menus/6",
      "@type": "Menu",
      "id": 6,
      "label": "TEST INTERNAL LINK",
      "targetEntity": "Challenge",
      "targetId": 31,
      "link": "",
      "position": 5
    }
*/
export const getFormattedMenuItems = (
  customMenuItems: PartialMenuItemType[],
  canAccessStore?: boolean,
  canAccessContact?: boolean,
): MenuItemType[] => {
  const customMenuItemsFormatted: MenuItemType[] = [];
  customMenuItems.forEach((menuItem) => {
    if (menuItem.link) {
      const externalMenuItem = createExternalLink(menuItem);
      customMenuItemsFormatted.push(externalMenuItem);
    } else {
      const maxMenuItem = createMaxMenuItem(menuItem);
      customMenuItemsFormatted.push(maxMenuItem);
    }
  });

  return [
    {
      id: 'home',
      label: tr('menu.home'),
      reactRoute: `${ROUTES.HOME}`,
    },
    ...(canAccessStore
      ? [
        {
          id: 'store',
          label: tr('menu.store'),
          externalRoute: `${ROUTES.STORE_HOME}`,
        },
      ]
      : []),
    ...customMenuItemsFormatted,
    ...(canAccessContact
      ? [
        {
          id: 'contact',
          label: tr('menu.contact'),
          externalRoute: `${ROUTES.STORE_CONTACT}`,
        },
      ]
      : []),
  ];
};
